export const RULE_STATUS = {
    UNSET: 'unset',
    VALID: 'valid',
    INVALID: 'invalid',
};

export const passwordField = 'password';
export const passwordLength = 'Length';
export const passwordNumbers = 'Numbers';
export const passwordSymbols = 'SpecialChars';
export const passwordLetters = 'Letters';
export const passwordGuess = 'EasyToGuess';
export const passwordRepetitive = 'RepeatedChars';
export const passwordWhiteSpace = 'WhiteSpace';
